import { getProductInventoryRpc } from '../../../__generated__/chirp/com/hubspot/buying/rpc/ProductRpc';
import { rpcClient } from '../../rpcClient';
import { logRavenException } from '../../errorUtils';
let CACHED_PRODUCT_INVENTORY = undefined;
export const fetchOwnedProductWithinSkuCategory = (skuCategoryName, isPublicUseCase = false) => {
  let ownedProductWithinSkuCategory = null;
  let promiseError = undefined;
  if (CACHED_PRODUCT_INVENTORY !== undefined) {
    return Promise.resolve({
      allOwnedProducts: CACHED_PRODUCT_INVENTORY,
      ownedProductWithinSkuCategory: CACHED_PRODUCT_INVENTORY == null || isPublicUseCase ? null : findOwnedHubTierWithinSkuCategory(skuCategoryName, CACHED_PRODUCT_INVENTORY)
    });
  }
  if (isPublicUseCase) {
    return Promise.resolve({
      allOwnedProducts: [],
      ownedProductWithinSkuCategory: null
    });
  }
  return rpcClient.call(getProductInventoryRpc, {}).then(productInventoryResponse => {
    CACHED_PRODUCT_INVENTORY = productInventoryResponse.products;
    ownedProductWithinSkuCategory = isPublicUseCase ? null : findOwnedHubTierWithinSkuCategory(skuCategoryName, productInventoryResponse.products);
  }, error => {
    CACHED_PRODUCT_INVENTORY = null;
    promiseError = error;
    logRavenException({
      error,
      customMessage: error.message,
      additionalDetails: {
        skuCategoryName
      }
    });
  }).catch(productInventoryError => {
    CACHED_PRODUCT_INVENTORY = null;
    promiseError = productInventoryError;
    logRavenException({
      error: productInventoryError,
      customMessage: 'fetchOwnedProductWithinSkuCategory: Promise successfully resolved but the catch block was triggered',
      additionalDetails: {
        skuCategoryName
      }
    });
  }).then(() => {
    if (promiseError) {
      console.error(promiseError);
    }
    return {
      allOwnedProducts: CACHED_PRODUCT_INVENTORY,
      ownedProductWithinSkuCategory
    };
  });
};
export function findOwnedHubTierWithinSkuCategory(skuCategoryName, portalInventory) {
  // If the skuCategory name for the feature table is not CRM_SUITE, we want to
  // try to unbundle all owned products to see if they own any tier of the
  // products requested in the feature table
  const shouldUnbundle = skuCategoryName !== 'CRM_SUITE';
  let ownedHubTierWithinSkuCategory = null;
  const ownedProductsWithinSkuCategory = portalInventory.filter(shouldUnbundle ? product => {
    var _product$skuCategoryN;
    return ['CRM_SUITE', skuCategoryName].includes(((_product$skuCategoryN = product.skuCategoryName) === null || _product$skuCategoryN === void 0 ? void 0 : _product$skuCategoryN.toString()) || '');
  } : product => product.skuCategoryName === skuCategoryName);
  for (const product of ownedProductsWithinSkuCategory) {
    if (shouldUnbundle) {
      if (product.skuCategoryName === skuCategoryName &&
      // All existing hub-like products are expected to have both a productLevel and
      // productLine values
      // https://hubspot.slack.com/archives/C08880GNTLP/p1759864521333929?thread_ts=1759862284.679939&cid=C08880GNTLP
      product.productLevel && product.productLine) {
        ownedHubTierWithinSkuCategory = product.productApiName;
        break;
      } else {
        var _product$bundledProdu;
        ownedHubTierWithinSkuCategory = ((_product$bundledProdu = product.bundledProducts.find(bundledProduct => bundledProduct.skuCategoryName === skuCategoryName)) === null || _product$bundledProdu === void 0 ? void 0 : _product$bundledProdu.productApiName) || null;
        break;
      }
    }
  }
  return ownedHubTierWithinSkuCategory;
}

// The following function is used to reset the cache for testing purposes ONLY
export const resetCachedProductInventory = () => {
  CACHED_PRODUCT_INVENTORY = undefined;
};